import { render, staticRenderFns } from "./InputPrecognition.vue?vue&type=template&id=74347beb&scoped=true"
import script from "./InputPrecognition.vue?vue&type=script&lang=js"
export * from "./InputPrecognition.vue?vue&type=script&lang=js"
import style0 from "./InputPrecognition.vue?vue&type=style&index=0&id=74347beb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74347beb",
  null
  
)

export default component.exports